module.exports = __webpack_public_path__ + "img/zhedafushufrst.88f6b8e2.png";